import React from 'react';
import styled from 'styled-components';

interface IAdresse {
  adresse: string | undefined;
}

const Adresse: React.FC<IAdresse> = ({ adresse }) => {
  if (!adresse) return null;
  return (
    <AdresseStyle>
      <p dangerouslySetInnerHTML={{ __html: adresse }} />
    </AdresseStyle>
  );
};
const AdresseStyle = styled.div`
  position: relative;
  width: 100%;

  max-width: 200px;
  p {
    margin-top: -11px;
    margin-bottom: 20px;
    font-size: 11px !important;
  }
`;
export default Adresse;
